import { render, staticRenderFns } from "./GroupRole.vue?vue&type=template&id=5873a128&scoped=true&lang=pug"
import script from "./GroupRole.vue?vue&type=script&lang=js"
export * from "./GroupRole.vue?vue&type=script&lang=js"
import style0 from "./GroupRole.vue?vue&type=style&index=0&id=5873a128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5873a128",
  null
  
)

export default component.exports